<template>
  <div class="vh-100 outer home-featured" style="text-align: center">
    <div class="center">
      <h1>SCAN ME</h1>
      <img
        src="https://chart.googleapis.com/chart?chs=500x500&cht=qr&chl=progressive.quantes.nl&choe=UTF-8"
      />
      <h1>FOR A</h1>
      <h1>FREE GAME</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "InactiveScreen",
  components: {},
};
</script>

<style>
h1 {
  font-size: 120px;
  color: #fff;
  padding-bottom: 20px;
}
img {
  padding-bottom: 20px;
}
.outer {
  display: flex;
  align-items: center;
}
.center {
  margin: auto;
  padding: 10px;
}
.screen {
  /* background: url("~@/assets/home_bg.png") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%; */
  overflow: hidden; /* Hide scrollbars */
}
.home-featured {
  background-color: #e5e5e5;
  /* background-image: linear-gradient(to top right, purple, violet, orange); */
  background: linear-gradient(#6bc1d0, #9e9ea0);
  background-size: 600% 600%;
  -webkit-animation: gradanimate 0.1s ease infinite;
  animation: gradanimate 0.1s ease infinite;
}
@-webkit-keyframes gradanimate {
  0% {
    background-position: 2% 0%;
  }
  50% {
    background-position: 99% 100%;
  }
  100% {
    background-position: 2% 0%;
  }
}
@keyframes gradanimate {
  0% {
    background-position: 2% 0%;
  }
  50% {
    background-position: 99% 100%;
  }
  100% {
    background-position: 2% 0%;
  }
}
</style>
